<div class="main-notification hidden" #notification>
  {{notificationMessage}}
</div>